// extracted by mini-css-extract-plugin
module.exports = {"page-comp":"D_page-comp__Ty3zk"};